import React, {useState} from 'react';
import { withStyles } from "@mui/styles";
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography} from '@mui/material';
import {connect} from "trim-redux";
import {useTranslation} from "react-i18next";
import {Close} from "@mui/icons-material";
import {Styles} from "../../../../../config/design/styles";
import Button from "@mui/material/Button";
import {calculateCartItemPrice, currencySymbol, getMediaURL, price} from "../../../../../config/values";
import SubTitle from "../../../../components/elements/SubTitle";
import AddToCartBtn from "../../../front/products/components/AddToCartBtn";
import {ChevronRight} from "lucide-react";
function ViewCartItemsButton({carts,classes }) {
    const { t } = useTranslation();
    const [open,setOpen] = useState(false);

    return (
        <>
            <Button
                onClick={() => setOpen(true)}
                endIcon={<ChevronRight/>}
                color="secondary"
                variant="outlined"
            >
                {t('viewItems')}
            </Button>
            <Dialog  open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xs">
                <DialogTitle>
                    <SubTitle className="dialog-title" align="left">
                        {t('cartItems')}
                    </SubTitle>

                    <IconButton
                        onClick={() => setOpen(false)}
                        style={{position:"absolute",right:15,top:15}}
                        size="small"
                    >
                        <Close className="lucide-icon"/>
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <div className={classes.checkoutItems}>
                        {
                            carts.map((item,index) => (
                                <div className="checkoutItemsDetails" key={index}>
                                    <div className="content-holder flex-direction">
                                        <div className="img-holder">
                                            <img src={getMediaURL(item.product?.thumbnail,'square')} alt={item.product?.name}/>
                                        </div>
                                        <div>
                                            <SubTitle align="left">{item.product?.name} ({item.quantity})</SubTitle>
                                            <div className='actions'>
                                                <Typography><strong>{price(calculateCartItemPrice(item))} {currencySymbol}</strong></Typography>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </DialogContent>
            </Dialog>
        </>

    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(ViewCartItemsButton));
